
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3><inlineCode parentName="h3">{`findAll`}</inlineCode>{` | v3`}</h3>
    <p>{`A convenience method to find all instances of a styled component's rendered DOM node within a given DOM root.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import styled from 'styled-components'
import { findAll } from 'styled-components/test-utils'

const Foo = styled.div\`
  color: \${props => props.color};
\`

/**
 * Somewhere in your app:
 *
 * ReactDOM.render(
 *   <main>
 *     <Foo color="red" />
 *     <Foo color="green" />
 *   </main>, document.body
 * );
 */

// retrieves a NodeList of instances of "Foo" in the body (querySelectorAll under the hood)
findAll(document.body, Foo) // NodeList<HTMLDivElement> | null
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;